import { render, staticRenderFns } from "./v-loading.vue?vue&type=template&id=55f34daa&scoped=true&"
import script from "./v-loading.vue?vue&type=script&lang=js&"
export * from "./v-loading.vue?vue&type=script&lang=js&"
import style0 from "./v-loading.vue?vue&type=style&index=0&id=55f34daa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f34daa",
  null
  
)

export default component.exports